import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserSubscription } from 'src/app/models/user-subscription.model';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { UserSubscriptionService } from 'src/app/services/user-subscription.service';
import { CancelDialogComponent } from './cancel-dialog/cancel-dialog.component';
import { MatIcon } from "@angular/material/icon";
import { MatListModule } from "@angular/material/list";
import { MatCard, MatCardTitle, MatCardSubtitle, MatCardContent } from "@angular/material/card";
import { DatePipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
	selector: 'app-subscription-management',
	templateUrl: './subscription-management.component.html',
	styleUrls: ['./subscription-management.component.scss'],
    imports: [MatIcon, MatListModule, MatCard, MatCardTitle, MatCardSubtitle, MatCardContent, DatePipe, MatTooltipModule]
})
export class SubscriptionManagementComponent implements OnInit {
	subscriptions: UserSubscription[] = [];

	constructor(
		private subService: UserSubscriptionService,
		private tokenService: TokenStorageService,
		public dialog: MatDialog,
	) { }

	ngOnInit() {
		this.getUserSubs();
	}

	getUserSubs(): void {
		this.subscriptions = [];
		const queryParams = new Map([
			["userId", this.tokenService.getUser().id],
			['isActive', 'true'],
		]);

		this.subService.get(['SubscriptionsByUser'], queryParams).subscribe((result) => {
			this.subscriptions = result;
		})
	}

	openCancelSubDialog(sub: UserSubscription): void {

		this.dialog.open(CancelDialogComponent, {
			data: sub
		});

		this.dialog.afterAllClosed.subscribe((result) => {
			//this.getUserSubs();
		});
	}
}
